import HttpService from "@/services/HttpService";
import Apis from "@/services/Apis";
import { defaultSelectedStrain } from "@/views/Strain/inputs";
import { searchEntities } from "@/services/entityService";
import Entities from "@/resources/Entities";

const state = {
  strains: [],
  strain: { ...defaultSelectedStrain },
  loadingStatus: {
    saveStrain: false,
    getStrains: false,
    getStrainById: false,
    deleteStrain: false,
    syncStrains: false,
  },
  sort: undefined,
  pagination: { skip: 0, limit: 20 },
  initialFilter: undefined
};

const mutations = {
  setLoadingStatus: (state, payload) => {
    if (payload) {
      state.loadingStatus[payload.api] = payload.status;
    }
  },
  setStrains: (state, payload) => {
    state.strains = payload;
  },

  setStrain: (state, payload) => {
    const defaultCopy = JSON.parse(JSON.stringify(defaultSelectedStrain));

    if (payload._id === "NEW") {
      searchEntities({
        filterCriteria: "isDefault",
        filterValue: "true",
        entity: Entities.STRAIN,
        skip: 0,
        limit: 1,
        positiveCallback: (data) => {
          state.strain = {
            ...defaultCopy,
            strain: data?.[0],
          };
        },
      });
    } else state.strain = { ...defaultCopy, ...payload };
  },

  updateSort: (state, payload) => {
    state.sort = payload;
  },
  updatePagination: (state, payload) => {
    state.pagination = payload;
  },
  updateInitialFilter: (state, payload) => {
    state.initialFilter = payload;
  },
};

const getters = {
  strains: (state) => state.strains,
  strain: (state) => state.strain,
  loadingStatus: (state) => state.loadingStatus,
  sort: (state) => state.sort,
  pagination: (state) => state.pagination,
  initialFilter: (state) => state.initialFilter,
};

const actions = {
  saveStrain: ({ commit, state }, payload) => {
    commit("setLoadingStatus", { api: "saveStrain", status: true });
    HttpService.post(
      Apis.backendBaseUrl + Apis.saveStrain,
      payload.strain,
      function (response, error) {
        commit("setLoadingStatus", { api: "saveStrain", status: false });
        if (response) {
          commit(
            "setMessage",
            { text: "Saved", type: "success" },
            { root: true }
          );
          if (payload.positiveCallback) {
            payload.positiveCallback(response.data.body);
          }
        } else {
          console.log(error);
          commit(
            "setMessage",
            { text: error.message, type: "error" },
            { root: true }
          );
        }
      }
    );
  },
  deleteStrain: ({ commit, state }, payload) => {
    commit("setLoadingStatus", { api: "deleteStrain", status: true });
    HttpService.post(
      Apis.backendBaseUrl + Apis.deleteStrain,
      payload.strain,
      function (response, error) {
        commit("setLoadingStatus", { api: "deleteStrain", status: false });
        if (response) {
          commit(
            "setMessage",
            { text: "Deleted", type: "success" },
            { root: true }
          );
          if (payload.positiveCallback) {
            payload.positiveCallback(response.data.body);
          }
        } else {
          console.log(error);
          commit(
            "setMessage",
            { text: error.message, type: "error" },
            { root: true }
          );
        }
      }
    );
  },
  getStrains: ({ commit, state }, payload) => {
    return new Promise((resolve, reject) => {
      commit("setLoadingStatus", { api: "getStrains", status: true });
      let url = Apis.backendBaseUrl + Apis.getStrains + "?";

      if (payload?.filterCriteria && payload?.filterValue) {
        url +=
          `&filterCriteria=${payload.filterCriteria}` +
          `&filterValue=${payload.filterValue}`;
      }

      HttpService.get(url, function (response, error) {
        commit("setLoadingStatus", { api: "getStrains", status: false });
        var strains = {};

        if (response) {
          strains = response.data.body;
          resolve(strains);
          commit("setStrains", strains);
          return;
        }

        reject(error);
      });
    });
  },
  getStrainById: ({ commit, state }, payload) => {
    commit("setLoadingStatus", { api: "getStrainById", status: true });
    HttpService.get(
      Apis.backendBaseUrl + Apis.getStrainById + "?id=" + payload._id,
      function (response, error) {
        commit("setLoadingStatus", { api: "getStrainById", status: false });
        if (response) {
          commit("setStrain", response.data.body);
          if (payload.positiveCallback) {
            payload.positiveCallback(response.data.body);
          }
        } else {
          commit(
            "setMessage",
            { text: error.message, type: "error" },
            { root: true }
          );
          console.log(error);
        }
      }
    );
  },
  getAdjacent: ({ commit, state }, payload) => {
    commit("setLoadingStatus", { api: "getAdjacentStrain", status: true });
    const mode = payload.mode ? payload.mode : "next";
    var url =
      Apis.backendBaseUrl + "strain/" + Apis.getAdjacent + "?mode=" + mode;
    if (payload.createdAt) url = url + "&date=" + payload.createdAt;
    HttpService.get(url, function (response, error) {
      commit("setLoadingStatus", { api: "getAdjacentStrain", status: false });
      if (response) {
        if (payload && payload.positiveCallback) {
          payload.positiveCallback(response.data.body);
        }
      }
    });
  },
  updateSort:({ commit, state }, payload) => {
    commit("updateSort", payload)
  },
  updatePagination:({ commit, state }, payload) => {
    commit("updatePagination", payload)
  },
  updateInitialFilter:({ commit, state }, payload) => {
    commit("updateInitialFilter", payload)
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};